import { InjectionToken } from '@angular/core';
import { identity } from 'rxjs';
import { EqaStringHandler } from '@shared/types/handler';

export const EQA_SVG_SRC_PROCESSOR: InjectionToken<EqaStringHandler<string>> = new InjectionToken<
	EqaStringHandler<string>
>('Source path processor for svg', {
	factory: () => identity,
});
